import React, { memo } from 'react';
import { Brain, Heart, Wallet, Users, AlertTriangle, ShieldAlert, Smartphone, MonitorOff } from 'lucide-react';
export function GamblingSignsSection() {
  return <section id="gambling-signs" className="py-20 md:py-28 bg-white" data-id="element-350">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-351">
        {/* PART A: Signs */}
        <div className="mb-16" data-id="element-352">
          <div className="text-center mb-12" data-id="element-353">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-354">
              What are the signs of problem gambling?
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-355" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-356">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-357">
              <div className="flex items-center gap-3 mb-4" data-id="element-358">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-359">
                  <Brain className="w-5 h-5 text-[#0A5E5C]" data-id="element-360" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-361">
                  Behavioral signs
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-362">
                <li className="flex items-start gap-2" data-id="element-363">
                  <span className="text-[#D4A843] mt-1" data-id="element-364">•</span>
                  <span data-id="element-365">constant thoughts about gambling</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-366">
                  <span className="text-[#D4A843] mt-1" data-id="element-367">•</span>
                  <span data-id="element-368">desire to increase bets</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-369">
                  <span className="text-[#D4A843] mt-1" data-id="element-370">•</span>
                  <span data-id="element-371">attempts to win back lost money</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-372">
                  <span className="text-[#D4A843] mt-1" data-id="element-373">•</span>
                  <span data-id="element-374">difficulty stopping the game</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-375">
                  <span className="text-[#D4A843] mt-1" data-id="element-376">•</span>
                  <span data-id="element-377">hiding gambling activity</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-378">
              <div className="flex items-center gap-3 mb-4" data-id="element-379">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-380">
                  <Heart className="w-5 h-5 text-[#0A5E5C]" data-id="element-381" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-382">
                  Emotional signs
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-383">
                <li className="flex items-start gap-2" data-id="element-384">
                  <span className="text-[#D4A843] mt-1" data-id="element-385">•</span>
                  <span data-id="element-386">feeling guilty after playing</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-387">
                  <span className="text-[#D4A843] mt-1" data-id="element-388">•</span>
                  <span data-id="element-389">irritability or anxiety when unable to play</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-390">
                  <span className="text-[#D4A843] mt-1" data-id="element-391">•</span>
                  <span data-id="element-392">using gambling to escape from stress or problems</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-393">
                  <span className="text-[#D4A843] mt-1" data-id="element-394">•</span>
                  <span data-id="element-395">feeling a loss of control</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-396">
              <div className="flex items-center gap-3 mb-4" data-id="element-397">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-398">
                  <Wallet className="w-5 h-5 text-[#0A5E5C]" data-id="element-399" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-400">
                  Financial signs
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-401">
                <li className="flex items-start gap-2" data-id="element-402">
                  <span className="text-[#D4A843] mt-1" data-id="element-403">•</span>
                  <span data-id="element-404">spending beyond one's means</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-405">
                  <span className="text-[#D4A843] mt-1" data-id="element-406">•</span>
                  <span data-id="element-407">loans or credits for gambling</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-408">
                  <span className="text-[#D4A843] mt-1" data-id="element-409">•</span>
                  <span data-id="element-410">debts or financial difficulties</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-411">
              <div className="flex items-center gap-3 mb-4" data-id="element-412">
                <div className="w-10 h-10 rounded-full bg-[#0A5E5C]/10 flex items-center justify-center" data-id="element-413">
                  <Users className="w-5 h-5 text-[#0A5E5C]" data-id="element-414" />
                </div>
                <h3 className="font-serif font-bold text-xl text-[#0A5E5C]" data-id="element-415">
                  Social signs
                </h3>
              </div>
              <ul className="space-y-2 text-gray-700" data-id="element-416">
                <li className="flex items-start gap-2" data-id="element-417">
                  <span className="text-[#D4A843] mt-1" data-id="element-418">•</span>
                  <span data-id="element-419">conflicts with family</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-420">
                  <span className="text-[#D4A843] mt-1" data-id="element-421">•</span>
                  <span data-id="element-422">problems at work</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-423">
                  <span className="text-[#D4A843] mt-1" data-id="element-424">•</span>
                  <span data-id="element-425">social isolation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* PART B: Where to start */}
        <div className="mb-16" data-id="element-426">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-427">
            Where to start?
          </h3>
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-428">
            <p data-id="element-429">
              If gambling really affects your life and you are ready to admit
              it, or at least entertain the thought, this is already a
              successful start. After all, recognition and awareness require
              great strength, and if you have this strength to admit the current
              state of affairs in your life, you definitely have the strength to
              act to help yourself. It is very important to give this awareness
              space and not try to fight it or yourself. Try to explore with
              curiosity when and how you might have lost control of yourself and
              given it to the game, under what circumstances this happened, what
              exactly you felt and what could be the reason for such a decision,
              whether it was conscious, or you don't remember how you suddenly
              realized that you couldn't stop and didn't find the strength in
              yourself to admit it immediately.
            </p>
            <p data-id="element-430">
              If you have someone very close and safe for you, someone who
              accepts you and does not judge, you could share all these
              thoughts, memories, and feelings that arise in you during such an
              exploration. A kind, accepting look from a close, safe person can
              help a lot. Think about it, maybe there is a person nearby to whom
              you could open up and not be alone in this exploration of
              yourself.
            </p>
          </div>
        </div>

        {/* PART C: What to do to help yourself */}
        <div className="mb-16" data-id="element-431">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-432">
            What can you do to help yourself?
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-433">
            If you have decided to take control of your gambling, and believe
            that it is enough for you to simply increase your awareness of the
            gambling process, then the following simple but effective tips can
            help you.
          </p>

          <div className="space-y-6 mb-8" data-id="element-434">
            <div className="flex gap-4" data-id="element-435">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-436">
                1
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-437">
                <span className="font-bold text-[#0A5E5C]" data-id="element-438">
                  Set limits for yourself.
                </span>{' '}
                Determine the amount you can afford to spend on entertainment
                and do not exceed it.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-439">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-440">
                2
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-441">
                <span className="font-bold text-[#0A5E5C]" data-id="element-442">
                  Control your playing time.
                </span>{' '}
                Set time limits or use a timer.
              </p>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-xl ml-12 my-6" data-id="element-443">
              <div className="flex items-start gap-4" data-id="element-444">
                <AlertTriangle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" data-id="element-445" />
                <p className="text-yellow-800 font-medium leading-relaxed" data-id="element-446">
                  Remember: on legal sites, you cannot be allowed to play
                  without setting such limits yourself. Be mindful about setting
                  these limits.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-447">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-448">
                3
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-449">
                <span className="font-bold text-[#0A5E5C]" data-id="element-450">
                  Don't try to chase losses.
                </span>{' '}
                Attempts to win back lost money often lead to even greater
                losses.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-451">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-452">
                4
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-453">
                <span className="font-bold text-[#0A5E5C]" data-id="element-454">
                  Avoid gambling under emotional influence.
                </span>{' '}
                Stress, alcohol, or strong emotions can lead to impulsive
                decisions.
              </p>
            </div>

            <div className="flex gap-4" data-id="element-455">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center font-bold" data-id="element-456">
                5
              </div>
              <p className="text-lg text-gray-700 pt-1" data-id="element-457">
                <span className="font-bold text-[#0A5E5C]" data-id="element-458">
                  Take regular breaks.
                </span>{' '}
                Regular pauses help maintain control.
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-459">
            During such pauses, try to analyze your behavior during the game,
            your general emotional state, and your emotional state directly
            during the game. Ask yourself if gambling is truly just
            entertainment for you, bringing positive emotions without any
            negative impacts on your financial state, emotional state, your
            thoughts, mood, your relationships with the outside world and the
            people around you. Try to do this analysis on a regular basis.
          </p>
        </div>

        {/* PART D: Serious steps */}
        <div data-id="element-460">
          <p className="text-lg text-gray-700 leading-relaxed font-medium mb-8" data-id="element-461">
            If you have realized that gambling negatively affects your life,
            mood, finances, relationships, thoughts, and have decided to act to
            change this, the following steps may be useful for you.
          </p>

          <div className="space-y-6" data-id="element-462">
            <div className="bg-[#0A5E5C] text-white p-8 rounded-2xl shadow-lg relative overflow-hidden" data-id="element-463">
              <ShieldAlert className="absolute -right-4 -bottom-4 w-32 h-32 text-white/10" data-id="element-464" />
              <div className="relative z-10" data-id="element-465">
                <h4 className="text-xl font-bold mb-4 flex items-center gap-3" data-id="element-466">
                  <span className="w-8 h-8 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-sm" data-id="element-467">
                    1
                  </span>
                  Self-exclusion
                </h4>
                <p className="text-lg mb-4 leading-relaxed" data-id="element-468">
                  Submit an application for self-exclusion through the website
                  of the State Agency "Playcity"{' '}
                  <a href="http://www.playcity.gov.ua" className="underline hover:text-[#D4A843] transition-colors" data-id="element-469">
                    www.playcity.gov.ua
                  </a>{' '}
                  in the "For Citizens" section there is an option "Application
                  for restriction", or you can submit such an application on the
                  website of any online gambling operator.
                </p>
                <div className="bg-white/10 p-4 rounded-lg space-y-3 text-sm" data-id="element-470">
                  <p data-id="element-471">
                    As a result of submitting such an application, your data
                    will be entered into the Register of persons whose access to
                    gambling establishments and/or participation in gambling is
                    restricted (hereinafter – the Register).
                  </p>
                  <p className="text-[#D4A843] font-medium" data-id="element-472">
                    But you must realize that entering your data into the
                    Register will restrict your access to gambling only with
                    legal gambling operators.
                  </p>
                </div>
              </div>
            </div>

            <p className="text-center text-gray-600 italic my-6" data-id="element-473">
              Therefore, you can use additional tools to help yourself and
              consciously restrict your access to gambling.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-474">
              <div className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-[#0A5E5C] transition-colors" data-id="element-475">
                <h4 className="text-lg font-bold text-[#0A5E5C] mb-3 flex items-center gap-3" data-id="element-476">
                  <span className="w-6 h-6 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-xs" data-id="element-477">
                    2
                  </span>
                  <Smartphone className="w-5 h-5" data-id="element-478" />
                  BETBLOCKER
                </h4>
                <p className="text-gray-700 mb-4 text-sm leading-relaxed" data-id="element-479">
                  Use the free blocking tool BETBLOCKER, which you can learn
                  about on the website{' '}
                  <a href="https://betblocker.org" className="text-[#0A5E5C] underline hover:text-[#D4A843]" data-id="element-480">
                    https://betblocker.org
                  </a>{' '}
                  or download it as a mobile app.
                </p>
                <p className="text-gray-500 text-xs" data-id="element-481">
                  This tool can be installed for various types of devices and
                  operating systems and it operates from the territory of
                  Ukraine, all information on the site and in the application is
                  in Ukrainian.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-[#0A5E5C] transition-colors" data-id="element-482">
                <h4 className="text-lg font-bold text-[#0A5E5C] mb-3 flex items-center gap-3" data-id="element-483">
                  <span className="w-6 h-6 rounded-full bg-[#D4A843] text-white flex items-center justify-center text-xs" data-id="element-484">
                    3
                  </span>
                  <MonitorOff className="w-5 h-5" data-id="element-485" />
                  Gamban
                </h4>
                <p className="text-gray-700 mb-4 text-sm leading-relaxed" data-id="element-486">
                  Use another blocking tool Gamban{' '}
                  <a href="https://gamban.com" className="text-[#0A5E5C] underline hover:text-[#D4A843]" data-id="element-487">
                    https://gamban.com
                  </a>
                </p>
                <p className="text-gray-500 text-xs" data-id="element-488">
                  This tool operates in Ukraine, but does not have a
                  Ukrainian-language version and it is paid (there is a free
                  trial version).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}